var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-btn',{on:{"click":_vm.migrateRevisions}},[_vm._v(" Migrate Revisions ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }